import React from "react";
// import axios from "axios";
// import LoadingDots from "../UI/LoadingDots";
import classes from "./APIPlaygroundComponents.module.scss";
import { tx } from "../../lib/ddd/ddd";

// const apiRequestAddress =
//   process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const availableApis = [
  {
    group: "Necessary",
    caption: "Minimum APIs",
    services: [
      // "EUeInvoices.AddCustomer",
      "EueInvoices.DDDI_GetNew",
      "EueInvoices.DDDI_Save",
    ],
  },
  {
    group: "Auxiliary",
    caption: "Additional APIs",
    services: [
      "EUeInvoices.DDDI_Status",
      "EUeInvoices.DDDI_ExecuteSteps",
      "EUeInvoices.DDDI_TransformedDocs",
      "EUeInvoices.DDDI_GetStorno",
      "EUeInvoices.DDDI_ReportsMake",
      "EUeInvoices.DDDI_ReportsSend",
      "EUeInvoices.DDDI_MakeAutoStorno",
      "EUeInvoices.DDDI_UploadMassFile",
      "EUeInvoices.DDDI_GenerateMass",
      "EUeInvoices.DDDI_GetList",
      "EUeInvoices.DDDI_GetExisting",
      "EUeInvoices.DDDI_GetRegistries",
      "EUeInvoices.DDDI_RegisterCashDeposit",
    ],
  },
  {
    group: "Rei",
    caption: "Recieved invoice APIs",
    services: [
      "EUeInvoices.DDDI_GetListREI",
      "EueInvoices.DDDI_GetExistingREI",
      "EueInvoices.DDDI_StatusREI",
      "EUeInvoices.DDDI_AcknowledgeREI",
    ],
  },
];

const AvailableAPIs = ({ onChooseApiHandler, activeApi }) => {
  const fontStyle = { fontSize : "0.9rem"};
  return (
    <>
      <div className={classes.container}>
        <div className={classes.groupMark}>Sending</div>
        <div style={{  }}>
          <h2>Necessary APIs</h2>
          <ol className={classes["available-apis-ol"]}>
            {availableApis
              .find((group) => group.group === "Necessary")
              .services.map((api, index) => {
                return (
                  <li
                    key={`api-${index}`}
                    onClick={() => onChooseApiHandler(api.split(".")[1])}
                    className="mb-2"
                    style={
                      api.split(".")[1] === activeApi
                        ? { ...fontStyle, color: "#df511d", fontWeight: "bold" }
                        : { ...fontStyle}
                    }
                  >
                    {tx(api.split(".")[1])}
                  </li>
                );
              })}
          </ol>
          <h2>Auxiliary APIs</h2>
          <ol className={classes["available-apis-ol"]}>
            {availableApis
              .find((group) => group.group === "Auxiliary")
              .services.map((api, index) => {
                return (
                  <li
                    key={`api-${index}`}
                    onClick={() => onChooseApiHandler(api.split(".")[1])}
                    className="mb-2"
                    style={
                      api.split(".")[1] === activeApi
                        ? { ...fontStyle, color: "#df511d", fontWeight: "bold" }
                        : { ...fontStyle}
                    }
                  >
                    {tx(api.split(".")[1])}
                  </li>
                );
              })}
          </ol>
        </div>
        <div className={`${classes.groupMark} mt-3`}>Receiving</div>
        <div style={{ maxHeight: "25%" }}>
          <ol className={classes["available-apis-ol"]}>
            {availableApis
              .find((group) => group.group === "Rei")
              .services.map((api, index) => {
                return (
                  <li
                    key={`api-${index}`}
                    onClick={() => onChooseApiHandler(api.split(".")[1])}
                    className="mb-2"
                    style={
                      api.split(".")[1] === activeApi
                        ? {...fontStyle, color: "#df511d", fontWeight: "bold" }
                        : {...fontStyle}
                    }
                  >
                    {tx(api.split(".")[1])}
                  </li>
                );
              })}
          </ol>
        </div>
      </div>
    </>
  );
};

export default AvailableAPIs;
